module.exports = __webpack_public_path__ + "img/repguide-wartung-teile.8030a390.jpg";